import { Suspense } from "react";
import Loading from "../../../shared/loading";

function SuspenseGuard(props: any) {
  return <Suspense fallback={<Loading />}>{props.children}</Suspense>;
}

export default SuspenseGuard;
